<template>
  <v-card
    elevation="0"
    class="card-box-shadow mt-0 w-100 pr-4"
    style="border-radius: 10px"
    :class="
      dataObj.pickup_details
        ? 'app-order-address'
        : 'app-order-address-done'
    "
  >
    <v-timeline align-top dense>
      <v-timeline-item
        color="primary"
        small
        v-for="(addressObj, index) in dataObj.pickup_details"
        :key="index"
      >
        <v-row no-gutters class="pt-1">
          <v-col>
            <h6 class="text_color--text text-caption">
              Pickup Address {{ index + 1 }}
            </h6>
            <h6 class="secondary--text">
              {{ addressObj.address }}
            </h6>
          </v-col>
        </v-row>
      </v-timeline-item>
      <v-timeline-item color="success" small v-if="dataObj.drop_details">
        <v-row no-gutters class="pt-1">
          <v-col>
            <h5 class="text_color--text text-caption">Drop Address</h5>
            <h6 class="secondary--text" v-if="dataObj.drop_details.address">
              {{ dataObj.drop_details.address }}
            </h6>
          </v-col>
        </v-row>
      </v-timeline-item>
    </v-timeline>
  </v-card>
</template>

<script>
export default {
  props: {
    dataObj: {
      required: true,
    },
  },
};
</script>